import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-column">
            <h3 className="footer-heading">GSPS Trading Corporation</h3>
            <p className="footer-description">
              Aftermarket spare parts for heavy commercial vehicles. Built for heavy duty, delivered with precision.
            </p>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Product</h3>
            <ul className="footer-links">
              <li><a href="#products">Products</a></li>
              <li><a href="#about">About Us</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Resources</h3>
            <ul className="footer-links">
              <li><a href="#contact">Contact</a></li>
              <li><a href="#home">Home</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>gspscorpn@yahoo.in</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92V19.92C22 20.52 21.52 21 20.92 21C9.4 21 0 11.6 0 0.08C0 -0.52 0.48 -1 1.08 -1H4.08C4.68 -1 5.16 -0.52 5.16 0.08V3.08C5.16 3.68 4.68 4.16 4.08 4.16H2.08C2.08 9.6 6.4 13.92 11.84 13.92H12.92C13.52 13.92 14 14.4 14 15V18C14 18.6 13.52 19.08 12.92 19.08H9.92C9.32 19.08 8.84 19.56 8.84 20.16V22.16C8.84 22.76 9.32 23.24 9.92 23.24H20.92C21.52 23.24 22 22.76 22 22.16V19.16C22 18.56 21.52 18.08 20.92 18.08H17.92C17.32 18.08 16.84 17.6 16.84 17V14C16.84 13.4 17.32 12.92 17.92 12.92H20.92C21.52 12.92 22 12.44 22 11.84V8.84C22 8.24 21.52 7.76 20.92 7.76H17.92C17.32 7.76 16.84 7.28 16.84 6.68V3.68C16.84 3.08 17.32 2.6 17.92 2.6H20.92C21.52 2.6 22 3.08 22 3.68V6.68C22 7.28 21.52 7.76 20.92 7.76H19.92" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>+91 9997873738</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>1581, 1st floor, church road, kashmere gate, new delhi, 110006</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="footer-copyright">© 2025 GSPS Trading Corporation. All rights reserved.</p>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

